import type { ComponentPropsWithoutRef } from "react";
import { ReactComponent as OutlineInfoCircle16 } from "assets/svg/outline-info-circle-16.svg";
import Checkbox from "components/checkbox/Checkbox";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import messages from "messages";
import styles from "./HideFromPublicView.module.scss";

const HideFromPublicView = ({
  className,
  ...props
}: Omit<ComponentPropsWithoutRef<typeof Checkbox>, "label">) => (
  <div className={styles["hide-from-public-view"] + " " + className}>
    <Checkbox
      label={messages.setSessionToPrivate}
      {...props}
      variant="rectangle"
    />
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip
          id="hide-from-public-view-tooltip"
          className={styles["hide-from-public-view__tooltip"]}
        >
          {messages.thisSessionWillNotBeVisible}
        </Tooltip>
      }
    >
      <OutlineInfoCircle16 className={styles["hide-from-public-view__icon"]} />
    </OverlayTrigger>
  </div>
);

export default HideFromPublicView;
